// extracted by mini-css-extract-plugin
export default {"addToCartControl":"UY-z","giftCard":"VY-z","btnContainer":"WY-z","cartButton":"XY-z","disabled":"YY-z"};